import Tool from '@recogito/annotorious/src/tools/Tool';
import RubberbandSegmentAnything from './RubberbandSegmentAnythng';
import EditableSegmentAnything from './EditableSegmentAnything';
import EditableMultipolygon from '../multipolygon/EditableMultipolygon';
import { isTouchDevice } from '@recogito/annotorious/src/util/Touch';

/**
 * A rubberband selector for Multipolygon fragments.
 */


const isTouch = isTouchDevice();
export const getPath = (points) => {
  const round = num => Math.round(10 * num) / 10;
  let path = ""
  for (let pointList of points){
    path += "M"
    let first = true
    for (let point of pointList){
      if (first){
        first = false
        path += round(point.x).toString() + "," + round(point.y).toString()
      } else {
        path += " L" + round(point.x).toString() + "," + round(point.y).toString()
      }
    }
    path += " Z"
  }
  return path
}

export const toSVGTarget = (points, image) => ({
  source: image?.src,
  selector: {
    type: "SvgSelector",
    value: `<svg><path d="${getPath(points)}" /></svg>`
  }
});

export default class RubberbandSegmentAnythingTool extends Tool {

  constructor(g, config, env) {
    super(g, config, env);
    this._isDrawing = false;
    this.viewer = null
    this._startOnSingleClick = false;
  }

  get isDrawing() {
    return this._isDrawing;
  }
  getXY = (a, b) => {

    // case 1: (x,y,evt)
    if (typeof a === 'number' && typeof b === 'number') {
      return { x: a, y: b };
    }

    // case 2: object event
    if (a && typeof a === 'object') {
      if ('x' in a && 'y' in a) {
        return a;
      }

      if (a.position) {
        return a.position;
      }

      if (a.detail?.position) {
        return a.detail.position;
      }
    }

    return null;
  }
  startDrawing = (x, y, startOnSingleClick, evt, contourPoints) => {
    console.log(evt);
    this._isDrawing = true
    this.startTime = Date.now()
    this.contourPoints = contourPoints;
    if (!startOnSingleClick){
      this._startOnSingleClick = false
    } else {
      this._startOnSingleClick = startOnSingleClick;
    }
    document.addEventListener('mousedown', function (e) {
      console.log("mousedown", e);
    });
    // this.svg.addEventListener('mousedown', this.onMouseDown);
    this.attachListeners({
      mouseMove: this.onMouseMove,
      mouseUp: this.onMouseUp,
      dblClick: this.onDblClick
    });

    this.rubberband = new RubberbandSegmentAnything([ x, y ], this.g, this.config, this.env, this.viewer);
    this.rubberband.on('close', ({ shape, selection }) => {
      shape.annotation = selection;
      this.emit('complete', shape);
      this.stop();
    });
  }

  stop = () => {
    this.detachListeners();

    this._isDrawing = false;

    if (this.rubberband) {
      this.rubberband.destroy();
      this.rubberband = null;
    }
  }
  undo = () =>{
    if (this.rubberband){
      this.rubberband.undo();

    }
  }


  newPart = () =>{
    if (this.rubberband){
      this.rubberband.newPart();

    }
  }
  setContourPoints(contourPoints, viewer){
  }

  onMouseMove = (x, y, evt) => {

    const pos = this.getXY(x, y);

    if (!pos || !this.rubberband)
      return;

    this.rubberband.dragTo({
      x: pos.x,
      y: pos.y,
      clickType: evt?.ctrlKey ? 0 : 1
    });
  }

  onMouseUp = (x, y, evt) => {

    const pos = this.getXY(x, y);

    if (!pos || !this.rubberband)
      return;

    const point = {
      x: pos.x,
      y: pos.y,
      clickType: evt?.ctrlKey ? 0 : 1
    };

    if (evt?.altKey) {
      this.complete();
    } else {
      this.rubberband.addPoint(point);
    }
  }
  onScaleChanged = scale => {
    if (this.rubberband)
      this.rubberband.onScaleChanged(scale);
  }
  scale = scale => {
  }
  complete = async (x, y) => {
    this._isDrawing = false;

    const shape = await this.rubberband.finalizePolygon();

    shape.annotation = this.rubberband.toSelection();
    console.log(shape.annotation);
    shape.annotation.segmentAnything = {
        tool: "segmentanything",
        started: this.startTime,
        finished: Date.now(),
    };
    shape.annotation["started"] = this.startTime;
    shape.annotation["finished"] = Date.now();
    console.log("complete", shape);

    this.emit('complete', shape);
    this.stop();
  }

  onDblClick = (x, y) => {
    if (this.config.completeWithDoubleClick){
      this.complete(x,y);
    }
  }

  createEditableShape = annotation => {
    annotation.started = this.startTime;
    annotation.Date = Date.now();
    return new EditableSegmentAnything(annotation, this.g, this.config, this.env);
  }
}

RubberbandSegmentAnythingTool.identifier = 'segmentanything';
//TODO IMPLEMENT A WAY TO DETERMINE IF ANNOTATION IS A SEGMENT ANYTHING
RubberbandSegmentAnythingTool.supports = annotation => {
  const selector = annotation.selector('SvgSelector');
  if (selector)
    return selector.value?.match(/^<svg.*<pathd d=/g);
}